import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../apiConfig";
import BannerPageTitle from "../Components/UIcomponents/BannerPageTitle";
import CommitteeCard from "./whoweare/components/CommitteeCard";

function CommitteePage() {
    const [committees, setCommittees] = useState([]);

    useEffect(() => {
        axios.get(`${API_BASE_URL}/committees`).then((res) => {
            const data = res.data.committees;
            const committeeList = data.map((item, index) => {
                return <CommitteeCard data={item} key={index} />
            });
            setCommittees(committeeList);
        });
    }, []);

    const styles = {
        cardWrapper: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: '2.5rem',
            justifyItems: 'center',
            alignItems: 'stretch'
        },
    };

    return (
        <div style={{ background: '#f4f6fa', minHeight: '100vh', paddingBottom: '4rem' }}>
            <BannerPageTitle 
                title='Committee' 
                subtitle='Meet the team driving BTCL forward'
            />
            <div style={{ 
                maxWidth: 'var(--maxWidth)', 
                margin: '-40px auto 0 auto', 
                padding: '3rem 2.5rem', 
                minHeight: '50vh', 
                background: '#ffffff', 
                borderRadius: '12px', 
                boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                position: 'relative',
                zIndex: 10,
                borderTop: '4px solid var(--blue)'
            }}>
                <div id="committees-wrapper" style={styles.cardWrapper}>
                    {committees}
                </div>
            </div>
        </div>
    );
}

export default CommitteePage;
